/* eslint-disable no-unused-vars */
import { useState } from 'react';
import CalendarLogicDesign from './CalendarUI';
import loading from "../../../assets/images/icons/refreshloader.gif"
import refreshicon from "../../../assets/images/icons/refresh.png";
import { AppConstant } from '../../../config/AppConstants';

const SESSION = {
  selectedZoneIDInCalendarScreen: 'selectedZoneIDInCalendarScreen',
  SelectedTranslation: 'selectedTranslation',
};

function formatDate(dateInput) {
  const d = new Date(dateInput);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function getWeekKeyFromDate(dateInput) {
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return null;

  date.setHours(0, 0, 0, 0);
  const dayOfWeek = date.getDay();
  const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  date.setDate(diff);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

const CalendarLogic = ({
  dayCellInfo,
  selectedDate,
  weekData,
  bookingSpotData,
  formatDateString,
  handleCancelBookingClick,
  handleShowBookingModal,
  loadingWeeks,
  setLoadingWeeks,
  fetchWithTokenRefresh2,
  BASE_URL,
  Calendar_api,
  getGuId,
  setWeekData,
  setCalendarRenderKey,
  creditInfoJSX,
  recordsData,
  isPastDate,
  selectedCalendarZoneId,
  ZoneList,
  handleJoinQueueModal,
  handleLeaveQueueModal,
  mapAvailable,
  mapAvailableType,
  setMapAvailable,
  setMapAvailableType,
  loadingDates,
  selectedTeamMember,
  isGuestFlag,
  selectedQueueUser,
  iconzoneType,
  handleVehicleNotAvailable,
  loadingprocessModal,
  filters
}) => {
  const currentDate = dayCellInfo.date;
   const today = new Date();
  const isNextWeek = currentDate > today;
  const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  // const currentDateString = currentDate.toISOString().slice(0, 10);
 const currentDateString = formatDate(currentDate);

  const isSelected = currentDateString === selectedDate;

  const firstDayOfWeek = new Date(currentDate);
  const dayOfWeek = firstDayOfWeek.getDay();
  const diff = firstDayOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  const mondayOfWeek = new Date(firstDayOfWeek.setDate(diff));
  mondayOfWeek.setHours(0, 0, 0, 0);
  const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;
 
  today.setHours(0, 0, 0, 0);
  const currentWeekMonday = new Date(today);
  const currentWeekDay = currentWeekMonday.getDay();
  const currentWeekDiff = currentWeekMonday.getDate() - currentWeekDay + (currentWeekDay === 0 ? -6 : 1);
  currentWeekMonday.setDate(currentWeekDiff);
  currentWeekMonday.setHours(0, 0, 0, 0);
  const isCurrentWeek = currentWeekMonday.getTime() === mondayOfWeek.getTime();
  const hasFetchedData = weekData.hasOwnProperty(weekKey);
  const monthWeekBookings = bookingSpotData.filter(
    (booking) => getWeekKeyFromDate(booking?.BookingDate) === weekKey
  );
  const weekBookings = (hasFetchedData || isCurrentWeek) ? (weekData[weekKey] || monthWeekBookings) : monthWeekBookings;

  // Debugging logs to inspect data
  console.log("Current Week Key:++++ TestCalendarLogic", weekKey);
  console.log("Week Bookings:++++ TestCalendarLogic", weekBookings);
  console.log("isGuestFlag passed to CalendarLogic:", isGuestFlag);

  const boundaryBookingOnDate = monthWeekBookings.find((booking) => {
    const bookingDate = formatDateString(booking.BookingDate);
    return (
      bookingDate.getFullYear() === cellDate.getFullYear() &&
      bookingDate.getMonth() === cellDate.getMonth() &&
      bookingDate.getDate() === cellDate.getDate()
    );
  });
  const isBoundaryDisabledDate =
    Number(boundaryBookingOnDate?.CurrentMonth) === 0 &&
    Number(boundaryBookingOnDate?.ActiveMonth) === 0;

  const bookingOnDate = (hasFetchedData || isCurrentWeek)
    ? weekBookings.find((booking) => {
        const bookingDate = formatDateString(booking.BookingDate);
        return (
          bookingDate.getFullYear() === cellDate.getFullYear() &&
          bookingDate.getMonth() === cellDate.getMonth() &&
          bookingDate.getDate() === cellDate.getDate()
        );
      })
    : isBoundaryDisabledDate
      ? boundaryBookingOnDate
      : undefined;

  const shouldHideRefreshIcon =
    currentDate.getDay() === 1 && isBoundaryDisabledDate;
  const shouldShowRefreshButton =
    currentDate.getDay() === 1 &&
    isNextWeek &&
    !hasFetchedData &&
    !shouldHideRefreshIcon;
  const shouldApplyWeekDateClass =
    !isCurrentWeek &&
    isNextWeek &&
    !hasFetchedData &&
    !shouldHideRefreshIcon &&
    !loadingWeeks[weekKey];

   if (bookingOnDate) {
    const matchedSchedules = bookingOnDate.Schedules || [];
    if (matchedSchedules.length > 0) {
      console.log("Selected SpotId:", matchedSchedules[0].SpotId); // Line 987
    } else {
      console.log("No SpotId found for this date."); // Line 990
    }
  } else {
    console.log("No booking found for this date.");
  }

  const dateNumber = currentDate.getDate();
  

  const [zoneList, setZoneList] = useState([]);
  const [selectedZoneName, setSelectedZoneName] = useState('Select Zone');
  const [multiBookingDates, setMultiBookingDates] = useState([]);

  let fetchButtonJSX = null;
  if (shouldShowRefreshButton) {
    fetchButtonJSX = (
      <button className='ctm-refresh-button'
        onClick={async (event) => {
          event.stopPropagation();
          setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
          try {
            // const zodedata = await ZoneList();

            // const responseCode = zodedata?.Data?.ResponseCode;
            // if (responseCode === 500) {
            //   console.log('zone errordata', responseCode);
            //   return;
            // } else if (responseCode == 200) {
            //   const fetchedZoneList = zodedata?.Data?.records?.zoneList ?? [];
            //   setZoneList(fetchedZoneList);

            //   if (fetchedZoneList.length > 0) {
            //     console.log('Fetched zone list:', multiBookingDates);

            //     const storedZoneIdString = localStorage.getItem(SESSION.selectedZoneIDInCalendarScreen);
            //     const storedZoneId = storedZoneIdString ? parseInt(storedZoneIdString, 10) : null;
            //     if (storedZoneId !== null && selectedCalendarZoneId === 0) {
            //       const defaultZoneData = fetchedZoneList.filter(
            //         (zone) => zone.id === storedZoneId
            //       );
            //       if (defaultZoneData.length > 0) {
            //         setSelectedZoneName(defaultZoneData[0].zoneName);
            //       } else {
            //         setSelectedZoneName(fetchedZoneList[0].zoneName);
            //       }
            //     } else if (selectedCalendarZoneId === 0 && storedZoneId === null && fetchedZoneList.length > 0) {
            //       setSelectedZoneName(fetchedZoneList[0].zoneName);
            //     }
            //   }
            // }

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            //  await new Promise((resolve) => setTimeout(resolve, 3000));

            const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                ZoneId: selectedCalendarZoneId,
                GuId: getGuId(),
                BookingStartDate: formattedDate,
                Month: month,
                Year: year,
                TeamMemberGuId: selectedTeamMember,
                FilterStartTime: filters?.FilterStartTime || "",
                DeviceId: '2b78fa68-e9b3-4265-ab25-d74a204d583f',
                OsVersion: '10',
                TagsFilter: filters?.TagsFilter || "",
                ManufactureModel: 'Android SDK built for x86',
                IsGuest: isGuestFlag,
                FuelFilter: filters?.FuelFilter || "",
                AppVersion: '12.15.0',
                ShareableFilter: filters?.ShareableFilter || "",
                Language: AppConstant.Language,
                FilterEndTime: filters?.FilterEndTime || "",
                VehicleTypeFilter: filters?.VehicleTypeFilter || "",
                IsFromAppHome: 0,
                AccessibleFilter: filters?.AccessibleFilter || "",
                FacilityFilter: filters?.FacilityFilter || "",
                LogScreenName: "",
                LogActionType: "",
                LogPopup: "",
                LogScreenName: "",
                LogActionType: "",
                LogPopup: ""
              }),
            });

            const data = await response.json();
            if (data?.Data?.Records?.Schedule) {
              setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
            } else {
              setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
            }

            // --- Update mapAvailable and mapAvailableType after refresh ---
            if (setMapAvailable && setMapAvailableType) {
              setMapAvailable(data?.Data?.Records?.MapExist ?? 0);
              setMapAvailableType(data?.Data?.Records?.MapType ?? 0);
            }
            // -------------------------------------------------------------

          } catch (error) {
            console.error('Fetch error:', error);
            setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
          } finally {
            setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
            setCalendarRenderKey((prev) => prev + 1);
          }
        }}
        disabled={loadingWeeks[weekKey]}
      >
        {loadingWeeks[weekKey]
          ? <div id='cal-preloader'><img src={loading} alt='Logo' /></div>
          : <img src={refreshicon} alt='Fetch Week Data' />}
      </button>
    );
  }

  return (
    <CalendarLogicDesign
      dateNumber={dateNumber}
      isSelected={isSelected}
      bookingOnDate={bookingOnDate}
      currentDateString={currentDateString}
      handleCancelBookingClick={handleCancelBookingClick}
      handleShowBookingModal={handleShowBookingModal}
      fetchButton={fetchButtonJSX}
      zoneList={zoneList}
      selectedZoneName={selectedZoneName}
      selectedCalendarZoneId={selectedCalendarZoneId}
      creditInfo={creditInfoJSX}
      recordsData={recordsData}
      isPastDate={isPastDate}
      shouldApplyWeekDateClass={shouldApplyWeekDateClass}
      isForcedDisabled={isBoundaryDisabledDate}
      handleJoinQueueModal={handleJoinQueueModal}
      handleLeaveQueueModal={handleLeaveQueueModal}

       loadingDates={loadingDates}
       mapAvailableType={mapAvailableType}
       iconzoneType={iconzoneType}
       handleVehicleNotAvailable={handleVehicleNotAvailable}
       loadingprocessModal={loadingprocessModal}
       selectedQueueUser={selectedQueueUser}
    />
  );
};

export default CalendarLogic;
